<template>
  <div class="dybossRecRecommend">
    <!--自動轉到加入好友頁面-->
    
    <a id='auto' href="http://line.me/ti/p/@782vpivq"></a>
    
    <a>很開心你也一起加入了喔～</a>
    <br />
    <img src="../assets/dayung.jpg">
    <br />
    <footer><a href="https://www.eilis-ai.com/">系統提供 by EILIS智慧互動助理</a></footer>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { mapGetters } from 'vuex'

export default {
  name: 'dybossRecRecommend',
  methods: {
    create: function() {
      this.$store.dispatch('getUserid', true)
    },
    receive: function() {
      this.$store.dispatch('rec_recommend', 
      {
        rec: this.recUserID,
        c: this.channelId
      })
    },
    getId: function() {
      this.$store.dispatch('getID', true)
    } 
  },
  computed: {
    ...mapGetters({
      userId: 'userId',
      Uid: 'Uid'
    }),
    ...mapGetters({
      channelId: 'channelId'
    })
  },
  mounted() {
    document.body.style.backgroundColor="#0A0201"
    // 導至邀請好友 //
    this.create()
    this.receive()
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
}
img {
  width: 70%;
  border-radius: 20%;
  margin-top: 10%;
}
</style>


// WEBPACK FOOTER //
// src/components/dybossRecRecommend.vue